import { TypeCode } from './type-code';

export class SearchParameter {
  constructor(
    public name: string,
    public values: string[],
    public type: TypeCode
  ) {}
}
